import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import neoMobileImage from '../../../assets/images/neoMobile.png';

const MobileFeaturesSection = () => {
  return (
    <div style={{ backgroundColor: '#ffffff', padding: '70px 0', position: 'relative', overflow: 'hidden' }}>
      <Container fluid className="px-4 px-xl-5 position-relative">
        <Row className="align-items-center">
          
          {/* Coluna da Esquerda: Imagem Mobile */}
          <Col lg={5} className="text-center text-lg-start mb-4 mb-lg-0 position-relative">
            <div className="position-relative" style={{ animation: 'fadeInLeft 1s ease-out', display: 'flex', justifyContent: 'center' }}>
              
              {/* Celular Gigante Translúcido (Efeito de Fundo/Sombra) */}
              <img 
                src={neoMobileImage} 
                alt="" 
                style={{ 
                  position: 'absolute',
                  top: '50%',
                  left: '25%', // Posicionado um pouco mais para a direita para emoldurar o celular menor
                  transform: 'translate(-50%, -50%) scale(1.8)', // Aumentei a escala para destacá-lo ainda mais
                  height: 'auto',
                  maxHeight: '800px', // Fica gigante proporcionalmente
                  opacity: 0.20, // Mais visível (antes era 0.08)
                  filter: 'blur(3px)', // Desfoque ajustado para melhor mesclagem com o fundo claro
                  zIndex: 0,
                  pointerEvents: 'none',
                  userSelect: 'none'
                }} 
              />

              {/* Imagem Celular Principal (Menor, focada à frente mas levemente aumentada) */}
              <img 
                src={neoMobileImage} 
                alt="NeoApp no Mobile" 
                style={{ 
                  maxWidth: '100%', 
                  height: 'auto', 
                  maxHeight: 'clamp(350px, 40vw, 530px)', // Aumentado um pouco de volta
                  objectFit: 'contain', 
                  filter: 'drop-shadow(15px 15px 25px rgba(0,0,0,0.2))',
                  position: 'relative',
                  marginTop: '5%', // Reduzi um tiquinho à margem pra não quebrar muito o quadro
                  zIndex: 1 
                }} 
              />
            </div>
            {/* CSS Animation Local */}
            <style>
              {`
                @keyframes fadeInLeft {
                  from { transform: translateX(-40px); opacity: 0; }
                  to { transform: translateX(0); opacity: 1; }
                }
              `}
            </style>
          </Col>

          {/* Coluna da Direita: Textos */}
          <Col lg={7} className="position-relative">
            <div style={{ animation: 'fadeInRight 1s ease-out', marginTop: 'clamp(0px, 2vw, 20px)', marginLeft: 'clamp(0px, 4vw, 60px)' }}>
              
              {/* Box de Títulos (Sombra perfeitamente atrás do nome) */}
              <div style={{ position: 'relative', marginBottom: '1rem' }}>
                {/* Palavra de fundo (Sombra Outline Animada) */}
                <div 
                  className="position-absolute text-uppercase"
                  style={{
                    fontSize: 'clamp(5rem, 11vw, 12rem)', // Fundo flexível
                    fontWeight: 'bold',
                    color: 'transparent',
                    WebkitTextStroke: '2px rgba(0, 243, 255, 0.4)', 
                    top: '50%',
                    left: '0', 
                    zIndex: 0,
                    pointerEvents: 'none',
                    userSelect: 'none',
                    letterSpacing: '8px',
                    animation: 'floatingShadowMobile 8s ease-in-out infinite alternate',
                    transform: 'translateY(-50%)' // Centralizando verticalmente corretamente
                  }}
                >
                  MOBILE
                </div>

                {/* Título Principal */}
                <h2 className="mb-0 text-uppercase position-relative" style={{ lineHeight: '1', zIndex: 1 }}>
                  <span className="d-block" style={{ fontSize: 'clamp(3.5rem, 7vw, 8rem)', letterSpacing: '-2px', fontWeight: 'bold', color: '#2a3042', textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}>
                    MOBILE
                  </span>
                </h2>
              </div>

               {/* Subtítulo com Faixa Vertical Neon */}
               <div className="d-flex position-relative mt-4" style={{ zIndex: 2 }}>
                  <div 
                    style={{
                      width: '4px',
                      backgroundColor: '#00f3ff',
                      boxShadow: '0 0 8px #00f3ff, 0 0 15px rgba(0, 243, 255, 0.6)',
                      borderRadius: '2px',
                      marginRight: '15px',
                      flexShrink: 0
                    }}
                  ></div>
                  <p className="mb-0" style={{ 
                    color: '#495057', 
                    fontSize: 'clamp(1.1rem, 1.4vw, 1.4rem)', 
                    fontWeight: '400', 
                    maxWidth: '800px', 
                    lineHeight: '1.5'
                  }}>
                    Realize <strong>avaliações técnicas</strong> e faça o <strong>controle de presença</strong> diretamente do seu dispositivo móvel, tendo todas as <strong>funcionalidades adaptadas</strong> para facilitar sua gestão de qualquer lugar.
                  </p>
                </div>

                {/* Chamada para Ação */}
                <div className="mt-5" style={{ marginLeft: '19px' }}>
                  <a href="#fale-conosco" 
                     className="btn text-uppercase fw-bold"
                     style={{
                       backgroundColor: 'transparent',
                       border: '2px solid #00f3ff',
                       color: '#2a3042',
                       padding: '14px 35px',
                       fontSize: '1.05rem',
                       borderRadius: '12px',
                       letterSpacing: '1px',
                       transition: 'all 0.3s ease',
                       boxShadow: '0 8px 15px rgba(0, 243, 255, 0.2)',
                       textDecoration: 'none',
                       display: 'inline-block'
                     }}
                     onMouseOver={(e) => {
                       e.target.style.backgroundColor = '#00f3ff';
                       e.target.style.color = '#fff';
                       e.target.style.boxShadow = '0 12px 20px rgba(0, 243, 255, 0.4)';
                       e.target.style.transform = 'translateY(-2px)';
                     }}
                     onMouseOut={(e) => {
                       e.target.style.backgroundColor = 'transparent';
                       e.target.style.color = '#2a3042';
                       e.target.style.boxShadow = '0 8px 15px rgba(0, 243, 255, 0.2)';
                       e.target.style.transform = 'translateY(0)';
                     }}
                  >
                    Fale Conosco
                  </a>
                </div>
            </div>

            <style>
              {`
                @keyframes fadeInRight {
                  from { transform: translateX(40px); opacity: 0; }
                  to { transform: translateX(0); opacity: 1; }
                }
                @keyframes floatingShadowMobile {
                  from { transform: translateY(-50%) translateX(0px); }
                  to { transform: translateY(-50%) translateX(-15px); }
                }
              `}
            </style>
          </Col>
        </Row>

        {/* Rodapé da Sessão: Observação alinhada perfeitamente à esquerda */}
        <Row className="mt-4 pt-3">
          <Col lg={12} style={{ animation: 'fadeInUp 1s ease-out' }}>
            <div style={{ 
              backgroundColor: 'rgba(0, 243, 255, 0.03)', 
              borderLeft: '3px solid #00f3ff',
              padding: '12px 20px',
              borderRadius: '0 6px 6px 0',
              display: 'inline-block'
            }}>
              <p className="mb-0 text-start" style={{ fontSize: '0.9rem', color: '#6c757d', lineHeight: '1.5' }}>
                <i className="mdi mdi-information-outline me-2" style={{ color: '#00f3ff', fontSize: '1.1rem' }}></i>
                <strong>Observação:</strong> O sistema não é um aplicativo que exige download. Nosso software possui telas responsivas, perfeitamente adaptadas e otimizadas para o navegador do seu dispositivo móvel.
              </p>
            </div>
          </Col>
        </Row>
        
        <style>
          {`
            @keyframes fadeInUp {
              from { transform: translateY(30px); opacity: 0; }
              to { transform: translateY(0); opacity: 1; }
            }
          `}
        </style>
      </Container>
    </div>
  );
};

export default MobileFeaturesSection;
